export enum GlobalFilter {
	VEHICLE = 'vehicle',
	DATE = 'date',
}
